import {Component} from '@angular/core';

@Component({
    selector: 'tfl-system-transfer-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <g fill="none" fill-rule="evenodd">
                <g fill="#286090">
                    <path d="M9.773 1.037A5.532 5.532 0 0 0 8.671.006a9 9 0 1 1-8.31 6.46c.183.477.43.922.731 1.324a8 8 0 1 0 8.681-6.753z"/>
                    <path d="M9.78 6.595l2.08 2.08a.47.47 0 0 0 .66-.66l-2.88-2.88a.47.47 0 0 0-.66 0L6.1 8.015a.47.47 0 0 0 .66.66l2.08-2.08v6.44a.47.47 0 1 0 .93 0l.01-6.44z"/>
                </g>
                <path fill="#EA8C05" d="M2 4.368C2.088 5.357 3.066 6 4.483 6 6.012 6 6.98 5.329 6.98 4.277c0-.842-.556-1.303-1.941-1.6l-.7-.16c-.921-.202-1.287-.46-1.287-.909 0-.58.588-.96 1.477-.96.834 0 1.4.349 1.515.936h.839C6.813.66 5.85 0 4.557 0 3.144 0 2.195.66 2.195 1.632c0 .814.523 1.283 1.732 1.545l.857.19c.922.199 1.34.509 1.34.997 0 .568-.663.985-1.562.985-.95 0-1.617-.381-1.719-.981H2z"/>
            </g>
        </svg>
    `
})
export class SystemTransferIcon {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/system/system.transfer.icon.ts